import React, { useEffect, useState, useRef } from 'react'
import './AddVoucherHeadline.css';
import { Button, TextField } from '@mui/material';
import { Accordion, Col, Form, Row } from 'react-bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css';
import { useNavigate, useParams } from 'react-router-dom';
import {
  get_beneficiary,
  add_sanction_order,
  save_draft_sanction_order,
  update_draft_sanction_order,
  get_draft_sanction_order,
  submit_draft_sanction_order,
} from '../../helper/Api';
import { check_is_equal_sanction_voucher_amount } from '../../helper/Utils';
import { validateUploadDocument } from '../../helper/uploadValidation';
import {
  emptySanctionForm,
  emptyVoucher,
  hasDraftContent,
  buildSanctionOrderFormData,
  mapDraftDetailsToFormData,
  hasAnyOrderDocument,
} from '../../helper/sanctionOrderDraft';
import Voucher from './Voucher';
import ExistingDocLink from './ExistingDocLink';
import { FaPlus } from 'react-icons/fa';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import SanctionOrderModal from '../Modal/SanctionOrderModal';
import Spinner from '../Tools/spinner';
import SubHeader from '../Subheader/Subheader';
import CustomBreadcrumbs from '../Tools/Breadcumbs';

const AddVoucherHeadline = () => {
  const { draft_id: draftIdParam } = useParams();
  const { authData, financialYears } = useSelector((state) => state.authData);
  const fy_list = financialYears.payload.fy_list;
  const fyIdRef = useRef(localStorage.getItem('globalDateId'));
  const [formData, setFormData] = useState(emptySanctionForm());
  const [draftId, setDraftId] = useState(draftIdParam || null);
  const [vendor, setVendor] = useState({});
  const [vendorList, setVendorList] = useState([])
  const [isLoading, setIsloading] = useState(false);
  const [draftSaving, setDraftSaving] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showPreview, setShowPreview] = useState(false);
  const navigate = useNavigate();

  const fetch_list = async () => {
    const vendorResponse = await get_beneficiary({department_id: authData.user.department_id});
    if (vendorResponse.data.status) {
      setVendorList(vendorResponse.data.list);
    }
  }

  const loadDraft = async (id) => {
    try {
      setLoading(true);
      const res = await get_draft_sanction_order(id);
      if (res.data.status && res.data.details) {
        setFormData(mapDraftDetailsToFormData(res.data.details));
        setDraftId(res.data.details.id || id);
      } else {
        toast.error(res.data.message || 'Unable to load draft', {
          position: toast.POSITION.TOP_CENTER,
        });
        navigate('/draft-sanction-orders');
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || 'Unable to load draft', {
        position: toast.POSITION.TOP_CENTER,
      });
      navigate('/draft-sanction-orders');
    } finally {
      setLoading(false);
    }
  };

  const handlePageTrigger = () => {
      fyIdRef.current = localStorage.getItem('globalDateId');
  }

  useEffect(() => {
    fetch_list();
  }, [])

  useEffect(() => {
    if (draftIdParam) {
      loadDraft(draftIdParam);
    }
  }, [draftIdParam]);

  const handleInput = (e) => {
    const name = e.target.name;
    let value = e.target.value;
    if (name == 'sanction_order') {
      value = e.target.files;

      const result = validateUploadDocument(value[0]);
      if (!result.ok) {
        e.target.value = "";
        toast.error(result.message, {
          position: toast.POSITION.TOP_CENTER
        });
        return false;
      }
      setFormData((prev) => ({ ...prev, [name]: value }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  }

  const check_total_invoice_value = () => {
    let total_voucher = 0;
    let sanction_order_value = parseInt(formData.sanction_order_value > 0 ? formData.sanction_order_value : 0);
    let invoice_status = 1;
    let scheme_status = 1;
    let sub_heads_status = 1;
    let msg = '';
    formData.vouchers.forEach((voucher, voucherIndex) => {
      total_voucher += parseInt(voucher.total_voucher_value || 0);
      let total_invoice_value = 0;
      let total_sanction_value = 0;
      let each_voucher_value = parseInt(voucher.total_voucher_value);
      voucher.invoices.forEach((invoice, invoiceIndex) => {
        const invoiceLabel = `Invoice ${invoiceIndex + 1}`;
        total_invoice_value += parseInt(invoice.invoice_value > 0 ? invoice.invoice_value : 0)
        total_sanction_value += parseInt(invoice.sanction_amount > 0 ? invoice.sanction_amount : 0)
        let each_invoice_value = parseInt(invoice.invoice_value);
        let each_invoice_sanction_amount = parseInt(invoice.sanction_amount);
        let total_scheme_value = 0;
        invoice.schemes.forEach((scheme) => {
          total_scheme_value += parseInt(scheme.amount > 0 ? scheme.amount : 0);
          let total_subheads_amount = 0;
          let each_scheme_amount = parseInt(scheme.amount > 0 ? scheme.amount : 0);
          let totalActivityBalance = 0;
          scheme.subheads.forEach((sub_head) => {
            if (sub_head) {
              total_subheads_amount += parseInt(sub_head.sub_head_amount > 0 ? sub_head.sub_head_amount : 0);
              if (sub_head && sub_head.activity) {
                sub_head.activity.forEach((activity) => {
                  if (activity.balance > 0) {
                    totalActivityBalance += parseInt(activity.balance, 10);
                  }
                });
              }
            }
          })
          if (total_subheads_amount !== each_scheme_amount) {
            sub_heads_status = 0;
            msg = `${invoiceLabel}: subhead amount does not match the scheme amount`;
          }
          if (total_subheads_amount < totalActivityBalance) {
            sub_heads_status = 0;
            msg = `${invoiceLabel}: activity amount is greater than the subhead amount`;
          }
        })
        if (parseInt(invoice.payment) == 2) {

          if (total_scheme_value !== each_invoice_sanction_amount) {
            scheme_status = 0;
            msg = `${invoiceLabel}: scheme amount does not match the sanctioned amount`;
          }
        } else {
          if (total_scheme_value !== each_invoice_value) {
            scheme_status = 0;
            msg = `${invoiceLabel}: scheme amount does not match the invoice amount`;
          }
          if (each_invoice_sanction_amount !== each_invoice_value) {
            scheme_status = 0;
            msg = `${invoiceLabel}: sanctioned amount does not match the invoice amount`;
          }

        }

      })
      if (total_sanction_value !== each_voucher_value) {
        invoice_status = 0;
        msg = `Voucher ${voucherIndex + 1}: invoice sanctioned total does not match the voucher value`;
      }
    });
    let response = {
      status: true,
      msg: msg
    };
    if (sanction_order_value !== total_voucher) {
      response.status = false;
      response.msg = 'Total voucher value is not match with sanction order value...!';
      return response;
    }
    if (!invoice_status) {
      response.status = false;
      return response;
    }
    if (!scheme_status) {
      response.status = false;
      return response;
    }
    if (!sub_heads_status) {
      response.status = false;
      return response;
    }
    return response;
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setShowPreview(false);
    let check_status = check_total_invoice_value();
    if (check_status.status) {
      const formDataObject = buildSanctionOrderFormData(formData, {
        addedBy: authData.user.id,
        draftId,
        forLiveSubmit: true,
      });
      try {
        setIsloading(true);
        const sanction_order_response = draftId
          ? await submit_draft_sanction_order(draftId, formDataObject)
          : await add_sanction_order(formDataObject);
        if (sanction_order_response.data.status) {
          setIsloading(false);
          toast.success(sanction_order_response.data.message, {
            position: toast.POSITION.TOP_CENTER
          });
          navigate('/fund-invoice-list');
        } else {
          setIsloading(false);
          toast.error(sanction_order_response.data.message, {
            position: toast.POSITION.TOP_CENTER
          });
        }
      } catch (error) {
        setIsloading(false);
        toast.error(error?.response?.data?.message || 'Something went wrong', {
          position: toast.POSITION.TOP_CENTER
        });
      }
    } else {
      setIsloading(false);
      toast.error(check_status.msg, {
        position: toast.POSITION.TOP_CENTER
      });
    }
  }

  const handleSaveDraft = async () => {
    if (!hasDraftContent(formData)) {
      toast.error('Fill at least one field to save draft.', {
        position: toast.POSITION.TOP_CENTER,
      });
      return;
    }
    try {
      setDraftSaving(true);
      const formDataObject = buildSanctionOrderFormData(formData, {
        addedBy: authData.user.id,
        draftId,
      });
      const res = draftId
        ? await update_draft_sanction_order(draftId, formDataObject)
        : await save_draft_sanction_order(formDataObject);
      if (res.data.status) {
        const newId = res.data.draft_id || draftId;
        if (newId && !draftId) {
          setDraftId(newId);
          navigate(`/add-sanction-order/${newId}`, { replace: true });
        }
        toast.success(res.data.message || 'Draft saved successfully', {
          position: toast.POSITION.TOP_CENTER,
        });
      } else {
        toast.error(res.data.message || 'Unable to save draft', {
          position: toast.POSITION.TOP_CENTER,
        });
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || 'Unable to save draft', {
        position: toast.POSITION.TOP_CENTER,
      });
    } finally {
      setDraftSaving(false);
    }
  };

  const handleVendor = (e) => {
    if (e.target.value) {
      const id = e.target.value;
      if (id >= 0) {
        const matched = vendorList.find((v) => String(v.id) === String(id));
        setVendor(matched || {});
      } else {
        setVendor({});
      }
    } else {
      setVendor({});
    }
  }

  const addMoreVoucher = () => {
    const newVoucher = [...formData.vouchers];
    newVoucher.push(emptyVoucher());
    setFormData({
      ...formData,
      vouchers: newVoucher
    });
  }

  const isBlank = (value) => value === null || value === undefined || String(value).trim() === '';

  const findMissingRequired = (data) => {
    if (isBlank(data.sanction_order_no)) return 'Sanction Order No. is required.';
    if (isBlank(data.sanction_order_date)) return 'Sanction Order Date is required.';
    if (isBlank(data.sanction_order_value)) return 'Sanction Order Value is required.';
    for (let v = 0; v < (data.vouchers || []).length; v += 1) {
      const voucher = data.vouchers[v];
      const voucherLabel = `Voucher ${v + 1}`;
      if (isBlank(voucher.voucher_no)) return `${voucherLabel}: Voucher No. is required.`;
      if (isBlank(voucher.voucher_date)) return `${voucherLabel}: Voucher Date is required.`;
      if (isBlank(voucher.total_voucher_value)) return `${voucherLabel}: Total Voucher Value is required.`;
      for (let i = 0; i < (voucher.invoices || []).length; i += 1) {
        const invoice = voucher.invoices[i];
        const label = `Invoice ${i + 1}`;
        if (isBlank(invoice.vendor_id)) return `${label}: Vendor is required. Open that invoice and select a vendor.`;
        if (isBlank(invoice.vendor_account_id)) return `${label}: Vendor account is required.`;
        if (isBlank(invoice.invoice_no)) return `${label}: Invoice No. is required.`;
        if (isBlank(invoice.invoice_date)) return `${label}: Invoice Date is required.`;
        if (isBlank(invoice.invoice_value)) return `${label}: Invoice Value is required.`;
        if (isBlank(invoice.taxable_amount)) return `${label}: Taxable Amount is required.`;
        if (isBlank(invoice.sanction_amount)) return `${label}: Sanctioned Amount is required.`;
        for (const scheme of invoice.schemes || []) {
          if (isBlank(scheme.scheme_id)) return `${label}: Scheme is required.`;
          for (const subhead of scheme.subheads || []) {
            if (isBlank(subhead?.sub_heads_id)) return `${label}: Sub head is required.`;
            if (subhead?.sub_head_amount === null || subhead?.sub_head_amount === '') {
              return `${label}: Sub head amount is required.`;
            }
          }
        }
      }
    }
    return '';
  };

  const previewhandler = (e) => {
    e.preventDefault();
    const missing = findMissingRequired(formData);
    if (missing) {
      return toast.error(missing, {
        position: toast.POSITION.TOP_CENTER
      });
    }
    if (!checkSubHeadAmount(formData.vouchers)) {
      return toast.error('Enter Sub Head Amount', {
        position: toast.POSITION.TOP_CENTER
      });
    }
    if (!hasAnyOrderDocument(formData)) {
      return toast.error(
        'Upload at least one document: Sanction Order, Voucher, or Invoice Order.',
        { position: toast.POSITION.TOP_CENTER }
      );
    }
    setShowPreview(true);
  };

  const checkSubHeadAmount = (data) => {
    for (const voucher of data) {
      const invoices = voucher.invoices || [];
      for (const invoice of invoices) {
        const schemes = invoice.schemes || [];
        for (const scheme of schemes) {
          const subheads = scheme.subheads || [];
          for (const subhead of subheads) {
            const subHeadAmount = subhead.sub_head_amount;
            if (subHeadAmount === null || subHeadAmount === "") {
              return false;
            }
          }
        }
      }
    }
    return true;
  }


  return (
    <>
      <SanctionOrderModal showPreview={showPreview} setShowPreview={setShowPreview} formData={formData} handleSubmit={handleSubmit} vendorList={vendorList}></SanctionOrderModal>
      <SubHeader fy_list={fy_list} handlePageTrigger={handlePageTrigger}/>
      
      <Form noValidate onSubmit={previewhandler}>
        {loading && <div > <Spinner/> </div>}
        <div className="row" style={{ padding: "10px 16px" }}>
          <div className="col-md-6">
              <h4 style={{ color: "#28326f", margin:0}}>
                {draftId ? 'Continue Draft Sanction Order' : 'Add Sanction Order'}
              </h4>
              <CustomBreadcrumbs
                linksArray={draftId ? [{ label: 'Draft Sanction Orders', href: '/draft-sanction-orders' }] : []}
                title={draftId ? 'Continue Draft' : 'Add Sanction Order'}
              />
          </div>
          <div className="col-md-6">
            <div className="m-0 p-0 d-flex gap-2" style={{ width: "auto", float: "right" }}>
                <button
                  type="button"
                  className="navigation_button"
                  disabled={draftSaving || isLoading || loading}
                  onClick={handleSaveDraft}
                >
                  <span className="fs-14px">{draftSaving ? 'Saving…' : 'Save as Draft'}</span>
                </button>
                <button type="submit" className="submit_button" disabled={isLoading || loading}>
                  <span className="fs-14px">Submit For Approval</span>
                </button>
            </div>
          </div>
        </div>
        <div className="row">
          <div className='col-md-12 p-4'>
              <div className="card" style={{ padding: "14px 12px 12px" }}>
                <Row>
                  <Col md={4}>
                    <TextField
                      fullWidth
                      size="small"
                      label="Sanction Order No."
                      placeholder="Enter Sanction Order No."
                      value={formData.sanction_order_no ?? ""}
                      onChange={handleInput}
                      name="sanction_order_no"
                      required
                    />
                  </Col>
                  <Col md={4}>
                    <TextField
                      fullWidth
                      size="small"
                      label="Sanction Order Date."
                      type="date"
                      value={formData.sanction_order_date ?? ""}
                      onChange={handleInput}
                      name="sanction_order_date"
                      required
                      InputLabelProps={{ shrink: true }}
                    />
                  </Col>
                  <Col md={4}>
                    <TextField
                      fullWidth
                      size="small"
                      label="Sanction Order Value"
                      type="number"
                      placeholder="Enter Sanction Order Value."
                      value={formData.sanction_order_value ?? ""}
                      onChange={handleInput}
                      name="sanction_order_value"
                      required
                    />
                  </Col>
                </Row>
                <Row className="mt-3 align-items-center">
                  <Col md={4}>
                    <TextField
                      fullWidth
                      size="small"
                      label="Sanction Order (only pdf allowed under 5MB.)"
                      type="file"
                      name="sanction_order"
                      inputProps={{ accept: ".pdf,.jpeg,.jpg,.png" }}
                      InputLabelProps={{ shrink: true }}
                      onChange={handleInput}
                    />
                  </Col>
                  {formData.sanction_order_url ? (
                    <Col md={4}>
                      <ExistingDocLink
                        href={formData.sanction_order_url}
                        label="View existing sanction order"
                      />
                    </Col>
                  ) : null}
                </Row>
                <Row>
                  <Accordion defaultActiveKey="v_0" className="mt-2">
                    {
                      formData.vouchers.map((voucher, i) => {
                        return (
                          <>
                            <Accordion.Item eventKey={`v_${i}`}>
                              <Accordion.Header>Voucher - {i + 1} </Accordion.Header>
                              <Accordion.Body>
                                <Voucher handleInput={handleInput} formData={formData} handleVendor={handleVendor} vendorList={vendorList} vendor={vendor} setFormData={setFormData} voucherIndex={i} setLoading={setLoading} />
                              </Accordion.Body>
                            </Accordion.Item>
                          </>
                        );
                      })
                    }
                  </Accordion>
                  <Col md={6} className='pt-2'>
                    {
                      check_is_equal_sanction_voucher_amount(formData.sanction_order_value, formData.vouchers) ? "" : <Button variant="outlined" onClick={addMoreVoucher}><FaPlus />&nbsp;Add Another Voucher</Button>
                    }
                  </Col>
                </Row>
                <div className='m-auto mt-2 d-flex gap-2 justify-content-center'>
                  <Button
                    variant="outlined"
                    type="button"
                    disabled={draftSaving || isLoading}
                    onClick={handleSaveDraft}
                  >
                    {draftSaving ? 'Saving…' : 'Save as Draft'}
                  </Button>
                  <Button variant="contained" type='submit'
                    disabled={isLoading}
                  >{isLoading ? 'LOADING....' : 'Submit for Approval'}</Button>
                </div>
              </div>
          </div>
        </div>
      </Form>
    </>
  )
}

export default AddVoucherHeadline;
